import React from 'react';
import { motion } from 'framer-motion';

const WhyChooseCognitivePrism = () => {
	return (
		<>
			{/* Why Choose Analytical Prism Section */}
			<section className="relative min-h-screen flex items-center overflow-hidden py-8 sm:py-12 md:py-16 lg:py-20">
				{/* Background Image */}
				<div 
					className="absolute inset-0 z-0"
					style={{
						backgroundImage: 'url(/images/last-bg.png)',
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat'
					}}
				/>
				
				{/* Content Overlay */}
				<div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-8 sm:py-12 md:py-16 lg:py-20 w-full relative z-10">
					<div className="grid grid-cols-1 lg:grid-cols-1 gap-6 sm:gap-8 md:gap-10 lg:gap-12 items-center">
						{/* Left Side - Text Content */}
						<motion.div 
							className="relative z-10 text-center lg:text-left max-w-4xl mx-auto lg:mx-0"
							initial={{ x: -50, opacity: 0 }}
							whileInView={{ x: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, ease: "easeOut" }}
						>
							{/* Main Heading */}
							<h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-semibold font-source text-[#113861] mb-3 sm:mb-4 leading-tight">
								Why Choose
							</h2>
							<h3 className="  text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-source italic text-[#113861] mb-4 sm:mb-6 leading-tight">
								Analytical Prism?
							</h3>
							
							{/* Introductory Paragraph */}
							<p className="  pt-16 text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white font-sans font-regular leading-relaxed mb-6 sm:mb-8 max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0">
								Analytical Prism was created with a singular purpose, to help young minds see themselves clearly through the lens of applied psychology.
							</p>
							
							{/* Two Column Text Layout */}
							<div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
								{/* Left Column */}
								<div className="space-y-3 sm:space-y-4">
									<p className="text-xs sm:text-sm md:text-base lg:text-md xl:text-md text-white font-sans font-regular leading-relaxed">
										In a world cluttered with information and expectation, students often struggle with self-doubt, indecision, and comparison. Analytical Prism brings science, simplicity, and sensitivity together to decode human behaviour and enable self-discovery.
									</p>
								</div>
								
								{/* Right Column */}
								<div className="space-y-3 sm:space-y-4">
									<p className="text-xs sm:text-sm md:text-base lg:text-md xl:text-md text-white font-sans font-regular leading-relaxed">
										Our tools are designed to build Clarity, the emotion that drives confidence, direction, and purpose, while being deeply rooted in cultural intelligence, ensuring relevance and resonance in the Indian context.
									</p>
								</div>
							</div>
						</motion.div>

						
					</div>
				</div>
			</section>
		</>
	);
};

export default WhyChooseCognitivePrism;
